export default __webpack_public_path__ + "static/media/princessbed.ed004016.png";